import React, { useContext, useEffect, useState } from 'react'

import { DefaultEmptyList } from '@/src/components/ui/optimus/DefaultEmptyList'
import { ReminderCard } from '@/src/components/ui/optimus/ReminderCard'
import { PageStatusBlocker } from '@/src/components/ui/PageStatusBlocker'

import { OptimusContext } from './OptimusContextProvider'
import { OptimusReminderMapper, OptimusReminderService } from './service'

const ListReminders: React.FC = () => {
    const {
        reminderList,
        setReminderList,
        isFetchError,
        setIsFetchError,
        setLoanInfos,
        setIsFetchLoanInfos,
    } = useContext(OptimusContext)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    useEffect(() => {
        // On init
        if (window.liff === null) return
        setIsLoading(true)
        ;(async () => {
            // React 16 does not support async in useEffect
            try {
                const res = await OptimusReminderService.fetchReminderList()
                const loanInfo = await OptimusReminderService.fetchLoanInfo()
                setLoanInfos(loanInfo)
                setIsFetchLoanInfos(true)
                setReminderList(res.data)
                setIsLoading(false)
            } catch (error) {
                setIsFetchError(true)
                setIsLoading(false)
            }
        })().catch() // Fail silently
    }, [])

    const onSave = () => {
        window.liff?.closeWindow()
    }

    const reminderListItems = reminderList.map(OptimusReminderMapper.toUIReminderListItem)

    return (
        <PageStatusBlocker
            isLoading={isLoading}
            loadingText="กรุณารอสักครู่..."
            isError={isFetchError}
        >
            <div
                className={`bg-primary-active-gray min-h-screen max-h-full w-screen flex flex-col items-center justify-center px-8 gap-4 ${reminderList.length > 0 ? 'pt-6 pb-32' : 'py-6'}`}
            >
                {reminderList.length > 0 ? (
                    <>
                        {reminderListItems.map((item, idx) => (
                            <ReminderCard
                                key={idx}
                                repetition={item.repetition}
                                time={item.time}
                                until={item.until}
                                textMsg={item.textMsg}
                                reminderID={item.reminderID}
                            />
                        ))}
                        <div className="fixed w-screen px-4 pb-6 bg-white bottom-0 shadow-[rgba(18,18,64,0.04)_0px_-16px_16px_0px]">
                            <button
                                className="bg-primary-blue text-white p-3 rounded-xl mb-2 active:bg-bright-light-blue mt-6 w-full"
                                onClick={onSave}
                            >
                                บันทึก
                            </button>
                        </div>
                    </>
                ) : (
                    <DefaultEmptyList />
                )}
            </div>
        </PageStatusBlocker>
    )
}

export default ListReminders
